import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import NiloyDas from "../../assets/testimony/t-2.png";
import VandanaKadam from "../../assets/testimony/t-3.png";

const testimonialList = [
  [
    {
      img: NiloyDas,
      name: "NILOY DAS",
      position: "Country Category Manager",
      content:
        "I have been utilizing the services of Infrec Consultancy Services Ltd for over one year, and I find their services to be highly professional.INFREC have been very helpful in providing in-person consultations regarding investment portfolios and fund selection based on goals. The app for tracking fund performance and portfolio updates is highly convenient.Their thorough and diligent suggestions on various financial matters are highly professional and commendable. They have also provided prompt assistance with IT returns and guidance on investments across different asset classes. The prompt handling and timely completion of consultation and paperwork facilitated re-allocation of my investments and hassle-free management of my personal finances.",
    },
    {
      img: VandanaKadam,
      name: "Vandana Kadam",
      position: "Retired",
      content:
        "My association with Pravin More & his team is for only last  3 yrs. but we hv bonded very well on both professional & personal level.His quote” Perfection is not attainable, but if we chase perfection, at least we end up attaining excellence” is exactly what he does 😊.. Achieves excellence 👍Keep learning, keep growing and SKY is the limit",
    },
  ],
];

const Testimonials = () => {
  return (
    <section className="ezy__testimonial23 light py-14 md:py-24 bg-white relative z-[1]">
      <div className="max-w-7xl px-4 mx-auto">
        <div className="grid grid-cols-12 gap-6 items-center justify-between mb-6 md:mb-12">
          <div className="col-span-12">
            <h2 className="text-3xl font-bold leading-tight md:text-[40px] mb-4">
              Everyone should believe in What Our Clients Say
            </h2>
          </div>
        </div>

        <div className="mt-12">
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            spaceBetween={30}
            loop
            className="relative"
          >
            {testimonialList.flat().map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="flex justify-center">
                  <div className="bg-white max-w-7xl p-6 xl:p-10 flex flex-col sm:flex-row sm:items-center">
                    {/* Left side: Image, Name, Position */}
                    <div className="flex-shrink-0 mb-4 sm:mb-0 sm:mr-6 sm:w-auto w-full flex justify-center sm:items-center">
                      <img
                        src={testimonial.img}
                        alt={testimonial.name}
                        className="w-40 h-40 rounded-full border"
                      />
                    </div>
                    <div className="flex flex-col justify-center mb-4 sm:mb-0">
                      <h4 className="text-xl font-medium text-center sm:text-left">{testimonial.name}</h4>
                      <p className="text-sm mb-2 text-center sm:text-left">{testimonial.position}</p>
                    </div>

                    {/* Right side: Content */}
                    <div className="sm:ml-6 flex-1">
                      <p className="opacity-75 mb-2">{testimonial.content}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
